import { Button as ButtonBase, styled } from '@mui/material'

export const Button = styled(ButtonBase)({
  maxWidth: 384,
})
